/*
	One accordion behaviour for every FAQ list on the site: /pages/faq (sections/faq.liquid) and the
	questions column of /pages/contact-us (sections/contact-form.liquid) share this file rather than
	each carrying its own inline copy.

	A list opts in with `data-faq-accordion` on the element wrapping its `.faq-item`s. Opening one
	question closes the others IN THAT LIST only, so a page with several groups of questions does not
	reach across them — the earlier inline version queried the whole document.

	The question itself is a <button aria-expanded>, so the state is announced and the keyboard
	reaches it; the stylesheet turns the chevron off that same attribute.
*/
(function () {
	/* The answer is found through aria-controls, not through nextElementSibling: the question is
	   wrapped in a heading so screen readers can move between questions, which leaves the button
	   with no next sibling at all. The id is the link between the two either way. */
	function answerFor(question) {
		var id = question.getAttribute('aria-controls');
		return (id && document.getElementById(id)) || question.nextElementSibling;
	}

	function close(question) {
		question.setAttribute('aria-expanded', 'false');
		var answer = answerFor(question);
		if (answer) answer.style.display = 'none';
	}

	function wire(root) {
		root.querySelectorAll('.faq-question').forEach(function (question) {
			question.addEventListener('click', function () {
				var answer = answerFor(question);
				var isOpen = question.getAttribute('aria-expanded') === 'true';

				root.querySelectorAll('.faq-question[aria-expanded="true"]').forEach(function (other) {
					if (other !== question) close(other);
				});

				question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				if (answer) answer.style.display = isOpen ? 'none' : 'block';
			});
		});
	}

	function init() {
		document.querySelectorAll('[data-faq-accordion]').forEach(wire);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
